import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../../shared/dto-has-api.model';

@Api('api/app/conversation-source')
export class ConversationSourceDto extends DtoHasApi {
  id: number;
  name: string;
  typeId: number;
  screenRecordingSourceId: number | null;
  settings: string;
}
